// TextFieldWithHeading.js
import { Box, TextField, Typography } from "@mui/material";

function TextFieldWithHeading({
  heading,
  placeholder,
  multiline = false,
  rows = 5,
  type = "text", // default type is text
  value = "",     // added
  onChange = () => {}, // added
}) {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          fontSize: "17px",
          fontWeight: "400",
          lineHeight: "20.57px",
          pt: "16px",
          color: "#121212",
        }}
      >
        {heading}
      </Typography>
      {multiline ? (
        <TextField
          variant="outlined"
          multiline
          fullWidth
          rows={rows}
          placeholder={placeholder}
          value={value}       // added
          onChange={onChange} // added
          sx={{
            input: {
              bgcolor: "#ffffff",
              color: "#12121299",
              fontSize: "16px",
              boxSizing: "content-box",
              px: "4px",
              py: "11px",
              "&::placeholder": {
                color: "#12121299",
                opacity: 1,
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "12px",
              borderRadius: "8px",
              bgcolor: "#ffffff",
              my: "6px",
              "& fieldset": {
                border: "1px solid #000000",
              },
              "&:hover fieldset": {
                border: "1px solid #000000",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid #000000",
              },
            },
          }}
        />
      ) : (
        <TextField
          variant="outlined"
          fullWidth
          placeholder={placeholder}
          type={type}  
          value={value}
          onChange={onChange}
          sx={{
            input: {
              bgcolor: "#ffffff",
              color: "#12121299",
              fontSize: "16px",
              boxSizing: "content-box",
              px: "4px",
              py: "11px",
              "&::placeholder": {
                color: "#12121299",
                opacity: 1,
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "8px",
              borderRadius: "8px",
              bgcolor: "#ffffff",
              my: "6px",
              "& fieldset": {
                border: "1px solid #000000",
              },
              "&:hover fieldset": {
                border: "1px solid #000000",
              },
              "&.Mui-focused fieldset": {
                border: "1px solid #000000",
              },
            },
          }}
        />
      )}
    </Box>
  );
}

export default TextFieldWithHeading;
